import axios from "../../axios";

const getMainPartners = async function (accessToken) {
    try {
        const response = await axios.get('/deduction-fees/getMainPartners', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getMainPartners; 
